import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'
import type { PaginatedResponse } from '../types'

export interface RegistroAuditoria {
  id: number
  acao: 'create' | 'update' | 'delete' | string
  modelo: string
  objeto_id: string
  usuario: string | null
  usuario_email: string | null
  dados_antes: Record<string, unknown> | null
  dados_depois: Record<string, unknown> | null
  ip_address: string | null
  criado_em: string
}

interface AuditoriaListParams {
  modelo?: string
  acao?: string
  objeto_id?: string
  usuario?: string
  page?: number
}

export function useAuditoriaList(params?: AuditoriaListParams) {
  return useQuery({
    queryKey: ['auditoria', params],
    queryFn: async () => {
      const r = await api.get<PaginatedResponse<RegistroAuditoria>>('/auditoria/', {
        params,
      })
      return r.data
    },
    staleTime: 1000 * 30,
  })
}

export function useAuditoriaDetalhe(id: number | string) {
  return useQuery({
    queryKey: ['auditoria', id],
    queryFn: async () => {
      const r = await api.get<RegistroAuditoria>(`/auditoria/${id}/`)
      return r.data
    },
    enabled: !!id,
  })
}
